"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useTypedRouter = void 0;
var _router = require("next/router");
/**
 * TODO: after some testing add to presentation-utils
 *
 * A wrapper around `useRouter` that provides type safety for the query object.
 * If there is error, it will throw an error. So provide catch if you want to handle the error.
 *
 * @param schema - A zod schema that describes the shape of the query object.
 * @returns An object containing the typed query object and the rest of the router object.
 *
 * @example
 * const routerSchema = z.object({
 *  productListId: z.string().optional(),
 *  productListType: z
 *    .enum([ProductListType.Personal.toLowerCase(), ProductListType.Private.toLowerCase()])
 *    .optional()
 *    .transform((value) => capitalize(value))
 *    .catch(ProductListType.Personal.toLowerCase()),
 * });
 *
 * cosnt { query: { productListId, productListType } } = useTypedRouter(routerSchema);
 */ const useTypedRouter = (schema)=>{
    const { query, ...router } = (0, _router.useRouter)();
    return {
        query: schema.parse(query),
        ...router
    };
};
exports.useTypedRouter = useTypedRouter;
